<template lang="pug">
v-card(flat)
  v-card-text
    //- .payment#payment-request-button.mb-4(ref='payment')
    //- v-card.pa-2
    //- .subtitle.text-center or

    .pa-4
      .d-flex.justify-space-between.mb-4
        h3 Sponsor licence
        h3 £{{ licencePrice }}
      v-divider.mb-4
      .d-flex.justify-space-between.mb-4
        h3 Subtotal
        h3 £{{ licencePrice }}
      .d-flex.justify-space-between.mb-4
        h3 VAT({{ vatPercent }}%)
        h3 £{{ getLicencePriceByVatPercent }}
      v-divider.mb-4
      .d-flex.justify-space-between.mb-4
        h3 Total
        div
          h3
            span(v-if="promo_prc")
              | ({{ promo_prc }}%)
              | £{{ getLicencePriceByPromo }}
              | +
              | VAT £{{ getVatByPromo }}
              | =
              | £{{ getLicencePriceByPromo + getVatByPromo }}
            span(v-else)
              | £{{ licencePrice + getLicencePriceByVatPercent }}

      v-row.mb-4(align="center")
        v-col(:xs="8")
          v-text-field(
            outlined,
            label="Promo Code",
            hide-details,
            :error-messages="promo_error",
            v-model="promo"
          )
        v-col(:xs="4")
          v-btn(block, :loading="promo_loading", @click="checkPromo") apply

    v-row(v-if="isLoadingSecret", justify="center")
      v-col(md="12")
      v-progress-circular(indeterminate, :size="64")

    div(v-else)
      .mb-4.d-flex
        .headline Card details
        v-spacer
        img(src="@/assets/cards_logo.png", width="100")
      v-row.mb-4
        v-col(:xs="6")
          v-text-field(
            outlined,
            label="Receipt email",
            hide-details,
            v-model="email"
          )
      v-row.mb-4
        v-col(:xs="6")
          v-text-field(
            outlined,
            label="Given name",
            hide-details,
            v-model="firstName"
          )
        v-col(:xs="6")
          v-text-field(
            outlined,
            label="Family name",
            hide-details,
            v-model="lastName"
          )
      .mb-4
        .card.mb-2(ref="card")
        span.error--text {{ errorText }}
      v-btn(block, color="primary", :loading="isLoading", @click="purchase") pay
</template>

<script>
// eslint-disable-next-line no-undef
let stripe = Stripe(
    process.env.VUE_APP_STRIPE_KEY
);
let elements = stripe.elements();
let card;

export default {
  data() {
    return {
      isLoadingSecret: false,
      isLoading: false,
      secret: null,
      email: this.$auth.user().email,
      errorText: "",
      promo_error: "",
      promo_loading: false,
      promo: "",
      promo_prc: "",
      firstName: this.$auth.user().first_name,
      lastName: this.$auth.user().last_name,
      licencePrice: 450,
      vatPercent: 20,
    };
  },

  props: ["open"],

  mounted() {
    this.initPayment();
  },

  computed: {
    getLicencePriceByVatPercent() {
      return this.licencePrice / (100 / this.vatPercent);
    },

    getLicencePriceByPromo() {
      return (this.licencePrice * (100 - this.promo_prc)) / 100;
    },

    getVatByPromo() {
      return this.getLicencePriceByPromo / (100 / this.vatPercent);
    },
  },

  watch: {
    open(state) {
      if (state === true) {
        this.initPayment();
      } else {
        elements = stripe.elements();
        card = undefined;
      }
    },
  },

  methods: {
    checkPromo() {
      this.promo_prc = null;
      this.promo_error = null;
      this.promo_loading = true;
      this.axios
        .post("/payment/promo_code", {
          promo_code: this.promo,
        })
        .then((resp) => {
          this.promo_prc = resp.data.percent;
        })
        .catch((e) => {
          this.promo_error = e.response.data.Error;
        })
        .finally(() => (this.promo_loading = false));
    },

    initPayment() {
      card = elements.create("card");
      card.mount(this.$refs.card);

      card.addEventListener("change", ({ error }) => {
        if (error) {
          this.errorText = error.message;
        } else {
          this.errorText = "";
        }
      });

      // var paymentRequest = stripe.paymentRequest({
      //   country: 'US',
      //   currency: 'usd',
      //   total: {
      //     label: 'Pay now',
      //     amount: 1099,
      //   },
      //   requestPayerName: true,
      //   requestPayerEmail: true,
      // });
      // var prButton = elements.create('paymentRequestButton', {
      //   paymentRequest: paymentRequest,
      // });

      // // Check the availability of the Payment Request API first.
      // paymentRequest.canMakePayment().then(function(result) {
      //   if (result) {
      //     prButton.mount('#payment-request-button');
      //   } else {
      //     document.getElementById('payment-request-button').style.display = 'none';
      //   }
      // });
    },

    purchase() {
      if (this.errorText === "") {
        this.isLoading = true;
        const ID = this.$store.getters["usercase/currentUsercase"]?.ID ?? 0;
        this.axios
          .get(`/employer/case/${ID}/sponsorship/paysecret`, {
            params: {
              promo: this.promo,
              receipt_email: this.email,
              purchase_type: "expert",
            },
          })
          .then((resp) => {
            this.secret = resp.data.client_secret;
            stripe
              .confirmCardPayment(this.secret, {
                receipt_email: this.email,
                setup_future_usage: "off_session",
                payment_method: {
                  card: card,
                  billing_details: {
                    name: this.firstName + " " + this.lastName,
                  },
                },
              })
              .then((result) => {
                if (result.error) {
                  this.errorText = result.error.message;
                } else {
                  if (result.paymentIntent.status === "succeeded") {
                    setTimeout(() => {
                      this.isLoading = false;
                      this.$message.success("Succesfully paid");
                      this.$store.dispatch("usercase/refreshUsercaseList");
                      this.$store.dispatch(
                        "usercase/sponsorship/refreshOverview"
                      );
                      this.$store.dispatch(
                        "usercase/sponsorship/refreshOnlineApplication"
                      );
                      this.$emit("close");
                    }, 1000);

                    // window.location.reload();
                  }
                }
              });
          });
      }
    },
  },
};
</script>